import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  currentYear = new Date().getFullYear();

  socialLinks = [
    { id: 1, name: 'linkedin', img: 'assets/images/social-linkedin.svg', link: '#' },
    { id: 2, name: 'facebook', img: 'assets/images/social-facebook.svg', link: '#' },
    { id: 3, name: 'instagram', img: 'assets/images/social-instagram.svg', link: '#' },
    { id: 4, name: 'twitter', img: 'assets/images/social-twitter.svg', link: '#' },
    { id: 5, name: 'youtube', img: 'assets/images/social-youtube.svg', link: '#' },
  ];

}
